import { render } from "./languageDropdown.vue?vue&type=template&id=359e2d90&scoped=true&ts=true"
import script from "./languageDropdown.vue?vue&type=script&lang=ts"
export * from "./languageDropdown.vue?vue&type=script&lang=ts"

import "./languageDropdown.vue?vue&type=style&index=0&id=359e2d90&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-359e2d90"]])

export default __exports__